/**
 * AuditService - Service for fetching audit trail data
 *
 * Provides methods to retrieve audit logs for requests by requestNumber
 */

import { AuditResponse } from '../types/audit';
import { API_BASE_URL } from '../constants/config';
import { getAndSanitize } from '../shared/utils/sanitization';

export class AuditService {
  private baseUrl = `${API_BASE_URL}/api/audit`;

  private getAuthHeaders() {
    const token = getAndSanitize('token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  /**
   * Get audit trail by request number
   * Searches both Load and Withdraw requests
   */
  async getAuditByRequestNumber(requestNumber: string): Promise<AuditResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/${requestNumber}`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al obtener auditoría');
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('[AuditService] Error fetching audit:', error);
      throw error;
    }
  }
}

export const auditService = new AuditService();
